import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { App } from './App';

// Silent-SSO relay: when the hidden iframe created by silentLogin() (see
// authService.ts) is redirected back from Keycloak to /auth/callback with
// prompt=none, hand the result (code / error) up to the parent window and do
// NOT boot the SPA inside the iframe. The parent finishes the token exchange.
function relaySilentAuthIfFramed(): boolean {
  if (window.parent === window) return false;
  if (!window.location.pathname.startsWith('/auth/callback')) return false;
  const search = window.location.search;
  if (!/[?&](code|error)=/.test(search)) return false;
  try {
    window.parent.postMessage(
      { type: 'whp-silent-auth', search },
      window.location.origin,
    );
  } catch {
    // Parent will fall back to its timeout if the message can't be posted.
  }
  return true;
}

if (!relaySilentAuthIfFramed()) {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('root element missing');

  createRoot(rootEl).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
